
export enum SimulationMode  {
  simulator ='simulator',
  coverage = 'coverage',
  formation = 'formation'
}

